import * as apis from "@/api";
import { conversion, GetItemDuration } from "@/tool";
import { mapState, mapMutations } from "vuex";
import Award from "@/components/UI/award";
import Number from "@/components/AnimateNumber";
import UnpackgameInstanceItem from "@/components/UnpackgameInstanceItem";

export default {
  components: {
    "c-award": Award,
    "c-number": Number,
    "c-unpackgameInstance-item": UnpackgameInstanceItem,
  },
  data() {
    return {
      isShow: false,
      case_opened_awards: [],
      bgPos: 0,
      gameInstance_info: {},
      unpackgameInstance_item_show: false,
    };
  },
  props: {
    //当时case页面传入case_info
    case_info: {
      type: Object,
      default: () => ({}),
    },
    resetText: {
      type: String,
      default: "存入背包",
    },
    background: {
      type: String,
      default: "",
    },
    autoConvertCurrencyType: {
      default: 0,
    },
  },

  filters: {
    conversion,
    GetItemDuration,
  },
  computed: {
    ...mapState(["sellSound", "isMute"]),
    /** 开箱结果奖品金额合计 */
    case_opened_awards_amount: (vm) =>
      vm.case_opened_awards
        .filter((_) => !_.isConvert)
        .reduce((acc, { price }) => acc + price, 0),
    isUsingHappyCoin() {
      return this.isHappyCoin;
    },
    autoConvertCurrencyName() {
      return parseInt(this.autoConvertCurrencyType, 10) === 2 ? "金豆" : "欢乐豆";
    },
    isAutoConverted() {
      const currencyType = parseInt(this.autoConvertCurrencyType, 10);
      return currencyType === 1 || currencyType === 2 || this.isUsingHappyCoin;
    },
  },
  methods: {
    reset() {
      this.case_opened_awards = [];
      this.isShow = false;
      this.$emit('on-close');
    },
    resetItem(index) {
      this.case_opened_awards[index].isConvert = true;
      if (this.case_opened_awards_amount <= 0) {
        this.reset();
      }
    },
    pushItem(name, mSerial, itempic, rarity, price, roll) {
      var typename = name.match(/^(.*?)\s?(\(.*\))?$/)[1];
      var skinname = "";
      var dur = GetItemDuration(name);
      var strArr = typename.split("|");
      if (strArr.length > 1) {
        typename = strArr[0];
        skinname = strArr[1];
      }

      this.case_opened_awards.push({
        name: name,
        typename,
        skinname,
        dur,
        mSerial,
        itempic,
        rarity,
        price,
        isConvert: false,
        roll,
      });
    },
    async show() {
      this.bgPos = Math.floor(Math.random() * 100) % 3;
      //如果是case传入,并且是副本箱的母箱的话
      if (
        this.case_info &&
        this.case_info.caseId &&
        this.case_info.isEnableAccumulateCase &&
        this.case_info.accumulateExtraCaseId
      ) {
        await this.getGameInstance();
        this.isShow = true;
      } else {
        this.isShow = true;
      }
    },
    /** 开箱奖品折现 */
    async case_opened_awards_discount(award) {
      var awards_Serial = this.case_opened_awards
        .filter((_) => !_.isConvert)
        .map((award) => award.mSerial);

      if (award) {
        awards_Serial = [award.mSerial];
      }

      const awards_discount_response = await apis.api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      // if (!this.isMute) {
      //   this.sellSound.pause();
      //   this.sellSound.currentTime = 0;
      //   this.sellSound.play();
      // }

      //this.awards_modal_flag = false;

      this.$toast.success(awards_discount_response.data.msg, {
        timeout: 2000,
      });

      // 延迟0.5秒更新用户信息
      setTimeout(() => {
        this.$store.commit("setInfo");
      }, 1000);

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.isConvert = true;
        }
      });

      if (this.case_opened_awards_amount <= 0) {
        this.reset();
      }
    },
    //获取副本箱详情
    async getGameInstance() {
      //这里的母箱必须是更新最新版
      const case_info_res = await apis.api_CaseDetail(this.case_info.caseId);
      let case_info_response = case_info_res.data.data.caseInfo;
      const gameInstance_response = await apis.api_CaseDetail(
        case_info_response.accumulateExtraCaseId
      );
      const respone = gameInstance_response.data.data;
      this.gameInstance_info = respone.caseInfo;
      case_info_response.accumulateCaseRoundCount = parseInt(
        case_info_response.accumulateCaseRoundCount
      );
      case_info_response.accumulateCaseRate = parseInt(
        case_info_response.accumulateCaseRate
      );
      this.gameInstance_info["isGameInstanceOpen"] = false;
      if (
        case_info_response.awardAccumulateExtraCases &&
        case_info_response.awardAccumulateExtraCases.length > 0
      ) {
        this.gameInstance_info["isGameInstanceOpen"] = true;
      } else {
        this.gameInstance_info["isGameInstanceOpen"] = false;
      }
      // // console.log("进来没", this.gameInstance_info.isGameInstanceOpen);
    },
    onGameInstanceBox() {
      if (this.gameInstance_info.isGameInstanceOpen) {
        this.unpackgameInstance_item_show = true;
      }
    },
    onUnpackgameInstanceClose(data) {
      //积累宝箱
      let obj = {
        awardAverageExtraCaseIndex: "",
        data: data,
      };
      this.$emit("on-onjileigameInstanceRewardCloseHandle", obj);
    },
  },
};
